<script>
const pageNum = 1;
const pageSize = 15;
//服务器
const sys_addr = "http://60.216.204.208:30008/wzapi/jeecg-boot";

// const sys_addr = location.href.substring(0, location.href.lastIndexOf(":")) + ":8088/jeecg-boot";

//机构的顶级id
const orgSuperId = '-1';
//待清洗组织机构
const waitwashOrgSupercode = '-1';
//主数据类型顶级id
const mdtypeSuperId = '-1';
//项目知识体系顶级id
const milstoneid = '-1';
//数据类别顶级id
const categorySuperId = '-1';
//角色顶级id0
const infoSuperId = '-1';
//用戶顶级id
const roleSuperId = '-1';

//组织顶级id
const infoOrgSuperId = '-1';
//项目知识体系的顶级id
const milestoneSuperId = '-1';
//属性值集id
const basedataSuperId = '-1';
//数据类别顶级id
const supercateid = '-1';
//功能顶级id
const superfunid = '-1';
//超级管理员
const superman = 'admin';

const superIndmgeId = '-1';

let currUser = '';
if (sessionStorage.getItem("userinfo") != '') {
	currUser = JSON.parse(sessionStorage.getItem("userinfo"));
}


const permMap = JSON.parse(sessionStorage.getItem("permMap"));

//默认配置信息
const baseExcelInfoInit = {
	container: "luckysheet",
	lang: 'zh',
	// 是否显示顶部信息栏
	showinfobar: false,
	showtoolbar: false, // 工具栏
	showtoolbarConfig: {
		image: false,
		print: false,
	},
	showsheetbar: false, // 底部sheet
	showsheetbarConfig: {
		add: false,
		menu: false,
	},
	showstatisticBar: false,//右侧底部
	showstatisticBarConfig: {
		count: false, // 计数栏
		view: false, // 打印视图
		zoom: true, // 缩放
	},
	// enableAddRow:false,
	cellRightClickConfig: {
		copy: true, // 复制
		copyAs: true, // 复制为
		paste: false, // 粘贴
		insertRow: false, // 插入行
		insertColumn: false, // 插入列
		deleteRow: true, // 删除选中行
		deleteColumn: false, // 删除选中列
		deleteCell: false, // 删除单元格
		hideRow: false, // 隐藏选中行和显示选中行
		hideColumn: false, // 隐藏选中列和显示选中列
		rowHeight: false, // 行高
		columnWidth: false, // 列宽
		clear: false, // 清除内容
		matrix: false, // 矩阵操作选区
		sort: false, // 排序选区
		filter: false, // 筛选选区
		chart: false, // 图表生成
		image: false, // 插入图片
		link: false, // 插入链接
		data: false, // 数据验证
		cellFormat: false // 设置单元格格式
	},
};

//待办excel默认配置信息
const baseExcelDaibanInfoInit = {
	container: "luckysheet",
	lang: 'zh',
	// 是否显示顶部信息栏
	showinfobar: false,
	showtoolbar: false, // 工具栏
	showtoolbarConfig: {
		image: false,
		print: false,
	},
	showsheetbar: false, // 底部sheet
	showsheetbarConfig: {
		add: false,
		menu: false,
	},
	showstatisticBar: false,//右侧底部
	showstatisticBarConfig: {
		count: false, // 计数栏
		view: false, // 打印视图
		zoom: true, // 缩放
	},
	enableAddRow: false,
	enableAddBackTop: false,
	cellRightClickConfig: {
		copy: true, // 复制
		copyAs: true, // 复制为
		paste: false, // 粘贴
		insertRow: false, // 插入行
		insertColumn: false, // 插入列
		deleteRow: false, // 删除选中行
		deleteColumn: false, // 删除选中列
		deleteCell: false, // 删除单元格
		hideRow: false, // 隐藏选中行和显示选中行
		hideColumn: false, // 隐藏选中列和显示选中列
		rowHeight: false, // 行高
		columnWidth: false, // 列宽
		clear: false, // 清除内容
		matrix: false, // 矩阵操作选区
		sort: false, // 排序选区
		filter: false, // 筛选选区
		chart: false, // 图表生成
		image: false, // 插入图片
		link: false, // 插入链接
		data: false, // 数据验证
		cellFormat: false // 设置单元格格式
	}
}

//辅助操作
const auxiLiaryExplanationCom = {
	starterid: '',//申请人id
	starter: '',//申请人
	status: '1',  //任务单状态:1-新增 2-特殊提交 3-待维护业务视图 4-拒绝 5-已变更 6-拒绝变更 7-变更完成 8-清洗 9-作废 10-拒绝清洗 11-新增完成 12-变更
	billid: '',  //单据id
	billname: '',  //单据名称
	field: '',    //属性字段
	modelid: '',  //模型id
	intro: '',  //简介
	starttime: '',  //申请时间
	descname: '',  //略称
	startdept: '',  //申请人部门id
	startdeptname: '',  //申请部门
	cateid: '',  //类别id
	catename: '',  //类别名称
	md: '',  //主数据id
	mdname: '',  //数据类型
	place: '',  //申请地点
	srcfrom: 'DMC',  //数据源头
	draftflag: '',  //提交状态:0-草稿 1-提交
	enable: '',  //状态:1-启动 0-禁用
	creater: '',  //创建人
	createdt: '',  //创建时间
	modifier: '',  //修改人
	modifydt: ''  //修改时间
}

//中文菜单****************************************************
const ChineseMap = {
	DamAlgConf: '算法绑定',
	Dashboard: '管理门户',
	personalportal: '个人门户',
	InfoMilestone: '项目管理',
	InfoKnow: '知识管理',
	SystemConstruction: '体系创建',
	SystemMain: '体系创建',
	'SystemMain?type=skipbill': '体系创建',
	'SystemMain?type=skipmodel': '体系创建',
	'SystemMain?type=skipview': '体系创建',
	'SystemMain?type=skippoperty': '体系创建',
	'SystemMain?type=skipencoder': '体系创建',
	'SystemMain?type=skipmencoder': '体系创建',
	ModelPage: '模型',
	InfoPoperty: '属性管理',
	InfoView: '视图管理',
	InfoEncoder: '规则编码',
	InfoModel: '模型管理',
	ProcessTab: '流程管理',
	Processmanagement: '流程管理',
	InfoNode: '流程节点',
	LeftTreeAndRightBill: '单据管理',
	InfoEncoderule: '编码规则',
	InfoBasedata: '属性值集',
	ValidRule: '验证规则',
	InfoAlg: '算法定义',
	CalculateSymbol: '质检算符',
	InfoCloudmodel: '云标准库',
	RelationValid: '关联定义',
	PropRelavalid: '关联绑定',
	InfoCategory: '数据类别',
	InfoMdtype: '数据类型',
	CateAndTaskbill: '数据维护',
	LeftTreeAndRightDaiban: '数据待办',
	LeftTreeAndRightHis: '数据历史',
	Waitwashpoy: '电力对照清洗',
	Changelog: '变更日志',
	WaitwashGoods: '对照清洗',
	WaitwashOther: '其他清洗',
	SecurityPanorama: '安全全景',
  TaskbillFile:"归档日志",
  FaceLogFile:"传输日志归档",
	// RelationValid: '其他清洗',
	WaitwashOrgTree: '映射清洗',
	CusInternSource: '内部资源库',
	// CusWashTrans: '清洗转换',
	// CusWashTrans: '客商清洗',
	WaitwashCust: '相似清洗',
	FaceDefine: '交换维护',
	InfoDictionary: '字典管理',
	DataQuery: '任务查询',
	QueryDataToBill: '数据查询',
	TaskQuery: '任务查询',
	BillStatus: '单据统计',
	DataEncoding: '数据统计',
	ExchangeStatics: '交换统计',
	StandardStatistics: "标准统计",
	KnowledgeOverview: "知识总览",
	FaceMonitor: "接口监控",
	Webmonitor: '应用监控',
	Runmonitor: '服务器监控',
	ProcStatics: '流程统计',
	ProcesshandlingStatics: '流程办理统计',
	FaceLog: '交换日志',
  infoDetectoinlog: '标准检测日志',
	FaceLogDb: '中间库日志',
	OperateLog: '操作日志',
  Masterdatacataloging: '主数据编目',
  MasterDataStatistics: '主数据统计',
  StrategyStatistics: '策略统计',
  DailyMaintenance: '日常统计',
  Userconfigurationstatistics: '用户配置统计',
	LoginLog: '登录日志',
	BasedatafaceLog: '属性值集日志',
	FactoryExpansionLog: '工厂扩充日志',
	EntityRelationship: '资源目录',
	BusinessRelations: '业务关系',
	IndexConfiguration: '指标配置',
	BloodMap: '血缘关系图谱',
	datawikipedia: '数据百科',
	datastorm: '数据风暴',
	ReportingPlatform: '报表平台',
	datamap: '数据地图',
	// FaceConfig: '报表平台',
	InfoFunction: '功能管理',
	InfoUser: '用户管理',
	InfoRole: '角色管理',
	InfoPost: '岗位管理',
	InfoOrg: '机构管理',
	authorization: '系统授权',
	PersonalSettings: '个人设置',
	MailboxManagement: '邮箱管理',
	MySchedule: '我的日程',
	InfoMsg: '通知公告',
	xtsy: '系统首页',
	KnowledgFlows: '知识流',
	InfoMsgshow: '消息通知',
	InfoCountKnow: '知识总量',
	WordPool: '词库定义',
	StandWord: '标准词定义',
	ScanStandard: '静态监测标准',
	DamQindex: '质量指标',
	ScanTasks: '静态任务调度',
	ScanTaskMonitor: '静态任务监控',
	ScanLogs: '静态调度日志',
	DamValiddef: '规则定义',
	DamPoolconf: '标准词绑定',
	DamValidconf: '规则绑定',
	DamSqldef: 'SQL定义',
	DamSqlconf: 'SQL绑定',
	ImportLog: '导入日志',
	// Merchants: '客商清洗',
	DamSimularconf: '相似度绑定',
	DamSimulardef: '相似度定义',
	ReportInfo: '报表列表',
	ReportType: '报表授权',
	ReportStart: '发起填报',
	ReportDaily: '待办报表',
	ReportQuery: '报表查询',
	ReportLog: '办理日志',
	// BIPlat: 'BI平台',
	PlanSysstruct: '体系架构',
	Knowqueryall: '知识搜索',
	//QueryByOrg: '查询权限',
	InteDatasource: '数据源',
	YsjInfoTask: '采集任务',
	YsjInfoDataentity: '检索分析',
	StandTaskbill: '标准待办',
	StandTaskbillHistory: '标准历史',
	ClientDetails: '第三方配置',
	ModelStatus: '模型统计',
	UserEmpower: '委托交接',
	Processtypestatistics: '流程类型统计',
	YsjInfoModule: '元数据模型',
	//MetaEntity: '元数据查询',
	//YsjInfoDataentity: '元数据查询',
	YsjInfoDataentityWeihu: '元数据维护',
	YsjInfoBusiterm: '术语管理',
	MetaAssetList: '资源目录',
	MeTadaTatemplate: '元数据子页面模板',
  YsjApiGatherAdapter: 'API采集适配',
	TermTableDetails: '常用术语详情页',
	MainBusisubject: '资源配置',
	DatasetAPI: '资源发布',
	YsjInfoTag: '数据标签',
	DataAssetPanorama: '资源全景',
	DatasetDataQuery: '资源数据查询',
	YsjLogGather: '采集日志',
	InfoDatagroup: '查询权限',
	YsjLogAudit: '审计日志',
	YsjInfoAdapter: '适配器',
	YsjInfoGather: '采集器',
	YsjInfoSource: '采集数据源',
	YsjInfoPathlabel: '目录维护',
	PlanningAndCost: '计划及造价管理',
	AnnualInvestmentPlan: '年度投资计划',
	DamEnvironmentQuestion: '环境评估',
	LoginOut: '登出日志',
	BudgetExamine: '工程概算编制',
	BudgetAdjust: '工程概算调整',
	ProjectChange: '工程变更编制',
	BiddingExecution: '招标执行情况',
	ContractSign: '合同签订信息',
	ContractPayment: '合同付款填报',
	ContractSettlement: '合同结算填报',
	YsjUseStatics: '元数据统计',
	SjzcInfoListmanage: '分类管理',
	SjzcInfoAssetcard: '资源目录',
	SjzcInfoApimanage: 'API发布',
	SjzcInfoDict: '资源字典',
	SjzcInfoApiapply: 'API授权',
	SjzcInfoCallapilog: 'API日志',
	ShipEoEntity: '关系配置',
	BiddingPlan: '招标计划',
	ShipEntitySearch: '实体搜索',
	ShipAllStatics: '实体全景',
	SjzcPanorama: '资源全景',
	ProjectPaymentPlan: '项目付款计划',
	VisualSchedulePlan: '形象进度分月计划',
	VisualScheduleExecute: '形象进度执行情况',
	IndexMan: '指标管理',
	ScenePersonnelMessage: '现场人员信息',
	ProjectSettlementPlan: '项目结算计划',
	YsjInfoDataentityShenHe: '元数据审核',
	Microservicemonitor: '微服务监控',
	FazhiConf: '阈值预警',
    ProcMonitor: '流程监控',
    BillStatistic: '单据流程统计',
	QualityWarning: '质量预警',
	InfoModelBuild: '模型管理',
	MulticodeEncoder: '业务编码',
	JhInfoAssetcard: '资源目录',
	InfoApi: 'API授权',
	InfoCallapilog: 'API日志',
	QueryDataToApi: '数据应用',
	DamDatasrcMan: '数据源管理',
	DamWashPolice: '策略配置',
	DamPoliceClean: '策略清洗',
	Businessexploration: '业务探查',
	YsjImportData: '元数据导入',
	FaceOneKey: '接口信息一键导入',
	CascadeOneKey: '级联校验一键导入',
	DescConfigOneKey: '描述配置一键导入',
	BillAuthOneKey: '单据权限一键导入',
	ColumnMatchOneKey: '接口字段一键导入',
	RelationBindOneKey: '关联绑定一键导入',
	RuleBindOneKey: '规则绑定一键导入',
	AlgorithmBindOneKey: '算法绑定一键导入',
	SimilarityBindOneKey: '相似度绑定一键导入',
	FaceWriteBackOneKey: '回写配置一键导入',
	FaceConditionOneKey: '条件触发一键导入',
	FaceNodeTrigerOneKey: '节点触发一键导入',
	FaceHttpOneKey: 'HTTP一键导入',
	FaceWebserviceOneKey: 'WEBSERVICE一键导入',
	BillNodePostOneKey: '节点岗位一键导入',
	InfoBillOneKey: '单据一键导入',
    InfoBillOutgoOneKey: '出口设置一键导入',
	InfoCategoryOneKey: '角色类别一键导入',
	RoleFuncOneKey: '角色功能一键导入',
	UserPostOneKey: '用户岗位一键导入',
	RoleOrgOneKey: '角色机构一键导入',
	PostOrgOneKey: '岗位组织一键导入',
	RoleBillOneKey: '角色单据一键导入',
  RoleViewAndPropOneKey: '角色数据查看权限一键导入',
	BillTypeprocOneKey: '单据流程一键导入',
	InfoTheme: '主题管理',
	InfoIndmge: '指标管理',
	InfoDimension: '维度管理',
	InfoAdjword: '修饰词管理',
	InfoCycletime: '时间周期管理',
	InfoZbcate: '指标分类',
	InfoBusprocess: '业务过程',
	InfoSourcesys: '指标字典',
	sjzbStatics: '指标全景',
  AppealManagement: '诉求管理',
	//数据资源新版菜单
	DirectoryManagement: '目录管理',
	LabelManagement: '标签管理',
	AssetCataloguing: '资源编目',
	InfoApimanage: 'API管理',
	AssetLoadingUnloading: '资源上下架',
	AssetRetrieval: '数据地图',
	AssetPanorama: '资源全景',
	AssetReleaseApproval: '资源发布审批',
	ApprovalRemoved: '上下架审批',
	APIReleaseApproval: 'API发布审批',
	APICallApproval: 'API调用审批',
	InfoSourceManage: '数据源管理',
	InfoAssetLog: '资源日志',
	EntityDataSource: '实体数据源',
	RelationshipConfiguration: '关系配置',
	EntitySearch: '实体搜索',
	PhysicalPanorama: '实体全景',
	InfoClassificat: '分类分级标准',
	AssetInfoProc: '资源流程管理',
	AssetDictionary: '资源字典',
	//数据安全菜单
	SecurityLevel: '安全级别定义',
	DesensitizationRule: '脱敏规则管理',
	AssetsSecurity: '资源安全配置',
	UserLevel: '用户级别',
	BlackWhiteRoll: '黑白名单配置',
	AssetsAPI: '资源API安全配置',
	//业务探查菜单
	Businessalert: '业务预警',
	Businessperspective: '业务透视',
    TcInfoTheme: '探查主题',
    TcInfoBusprocess: '探查业务过程',
	TcRule: '探查规则',
  TcPurviewConf: '权限配置',
	DbInfo: '探查数据源',
	TimeInfo: '周期管理',
	WarnPerspective: '业务预警',
	YwtsPerspective: '业务透视',
	YwtcStatic: '探查全景',
	TaskInfo: '任务调度',
	TaskLog: '调度日志',
  AssetsPrivilege: '资源权限配置',
  MasterDataShare:'主数据订阅',
  MDAPIAuth:'订阅管理',
  MDAPILog:'订阅日志',
  MdApiShenPi :'主数据订阅审批',
  ModelFBSP: '模型发布审批',
  TaskJianKong:'任务监控',
  Saomiaojieguo:'扫描结果',
  JiheTask:'稽核任务',
  JiheLog:'稽核日志',
  MinganWord:'敏感词',
  GuzePool:'规则池',
  DbResourceInfo:'检测数据源',
  YsjInfoSources:'采集数据源'
};

export default {
	sys_addr,
	superfunid,
	infoSuperId,
	waitwashOrgSupercode,
	milestoneSuperId,
	mdtypeSuperId,
	roleSuperId,
	pageNum,
	pageSize,
	orgSuperId,
	milstoneid,
	superman,
	superIndmgeId,
	supercateid,
	categorySuperId,
	basedataSuperId,
	ChineseMap,
	//不要注掉，影响功能
	currUser,
	permMap,
	baseExcelInfoInit,
	auxiLiaryExplanationCom,
	baseExcelDaibanInfoInit,
};


</script>
